<template>
  <div class="navbar">
    <nav class="blue-grey white-text darken-4" style="height: 67px;">
      <div class="nav-wrapper">
         <a class="brand-logo animated bounceIn left" href="/">
           <img src="../../assets/logowhite.png" alt="PMGC" width="50px" height="56px" class="responsive-img">
         </a>
        <ul class="right show-on-small-only hide-on-med-and-up">
          <a data-target="slide-out-mobile" class="sidenav-trigger">
            <i class="icon ion-navicon-round x35"/>
          </a>
        </ul>
        <ul id="slide-out-mobile" class="sidenav show-on-small-only hide-on-med-and-up" style="height: auto; width: auto"></ul>

        <ul id="slide-out-mobile" class="sidenav show-on-small-only blue-text hide-on-med-and-up" style="height: auto; width: auto">

          <li>
            <a @click="home">Home</a>
          </li>
          <li>
            <div class="divider"></div>
          </li>
          <li>
            <a @click="achievements">Achievements</a>
          </li>
          <li>
            <div class="divider"></div>
          </li>
          <li>
            <a @click="news">News</a>
          </li>
          <li>
            <div class="divider"></div>
          </li>
          <!-- <li>
            <a @click="gallery">Gallery</a>
          </li> -->
          <li>
            <div class="divider"></div>
          </li>
          <li>
            <a @click="aboutUs">About Us</a>
          </li>
           <li>
            <div class="divider"></div>
          </li>
          <li>
            <a @click="contactUs">Contact Us</a>
          </li>
        </ul>
        <ul class="right hide-on-small-only">
          <li>
            <router-link to="/" class="btn blue">Home</router-link>
          </li>
          <li>
            <router-link to="/achievements" class="btn blue ">Achievements</router-link>
          </li>
          <li>
            <router-link to="/news" class="btn blue">News</router-link>
          </li>
          <!-- <li>
            <router-link to="/gallery" class="btn blue">Gallery</router-link>
          </li> -->
          <li>
            <router-link to="/about" class="btn blue">About Us</router-link>
          </li>
          <li>
            <router-link to="/contact" class="btn blue">Contact Us</router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import M from 'materialize-css'
export default {
  mounted () {
    var elem = document.querySelector('#slide-out-mobile')
    // eslint-disable-next-line
    var instance = new M.Sidenav(elem, {
      edge: 'right',
      draggable: true
    })
  },
  methods: {
    home () {
      this.$router.push('/')
    },
    achievements () {
      this.$router.push('/achievements')
    },
    news () {
      this.$router.push('/news')
    },
    gallery () {
      this.$router.push('/gallery')
    },
    aboutUs () {
      this.$router.push('/about')
    },
    contactUs () {
      this.$router.push('/contact')
    }
  }
}
</script>

<style>
  div.navbar nav a{
    color: #fff !important;
    /* line-height: 39px; */
  }
  #slide-out-mobile > li > a {
    font-size: larger !important;
    color: #2691f3 !important;
  }
  div.navbar > nav > div > ul > li a:hover, div.navbar > nav > div > ul > li a:focus, div.navbar > nav > div > ul > li a:active, div.navbar > nav > div > ul > li a:visited {
    border-top: 2px solid #fff;
    border-bottom: 2px solid #fff;
  }
  div.nav-wrapper {
    padding-left: 2.9rem;
  }
   div.navbar > nav > div > ul > li > a.btn, #app > div > div.navbar > nav > div li > a.btn {
    font-size: 0.7rem;
    height: 30px;
    line-height: 30px;
    padding: 0 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/navbar.vue